'use client';

import type { ReactNode } from 'react';
import { useCurrentStepRoute } from '../../../components/useCurrentStepRoute';
import { FlowController } from '../../FlowController';
import { SummaryPanel, SummaryPanelProps } from '../../components/panels/SummaryPanel';
import type { SanityLicense } from '../../types/licenses';
import BillingDetails from './BillingDetails';

type BasketColumnProps = {
  license: SanityLicense;
  informationPanel?: ReactNode;
} & SummaryPanelProps;

export const BasketColumn = (props: BasketColumnProps) => {
  const { license } = props;
  const flow = new FlowController(license);
  const currentStepRoute = useCurrentStepRoute();

  if (!currentStepRoute || !flow.flowType) return null;

  const step = flow.getCurrentStep(currentStepRoute);
  const resolvePanelElement = (type: string) => {
    switch (type) {
      case 'info':
        return props.informationPanel ?? null;
      case 'summary':
        return <SummaryPanel {...props} key="summary" />;
      case 'basket':
        return <BillingDetails license={license} inBasketPanel key={'basket'} />;
      default:
        return null;
    }
  };

  return (
    <aside aria-label="License receipt / summary" className="font-graphik md:top-menu-height md:mt-0 md:block md:h-fit">
      <div className="flex flex-col gap-6">
        {step?.panels?.map(panel => {
          return resolvePanelElement(panel);
        })}
      </div>
    </aside>
  );
};
